import styled from 'styled-components'

export const ValueWrapper = styled.div`
	display: flex;
	height: 20px;
	min-width: 0;
`
